import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { Typography, Grid } from "@material-ui/core";
import Numberformat from "../../atoms/Numberformat";
import CoinPaymentsButton from "../../atoms/CoinPaymentsButton";

const styles = theme => ({});

class PaymentInfoDASH extends Component {
  render() {
    const { classes } = this.props;
    const { currency, OrderNumber, CoinPaymentsMerchantID } = this.props.order;
    const { sum, token } = this.props.order.display;
    const { first_name, last_name, email } = this.props.user;
    return (
      <div>
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <Typography gutterBottom>
              Send <Numberformat value={sum} />
              &nbsp;DASH and get <Numberformat value={token} digits={6} />
              &nbsp;CRWD&nbsp;Token to your Wallet
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            {/* TODO: merchant from backend holen */}
            <CoinPaymentsButton
              className={classes.dashbutton}
              merchant={CoinPaymentsMerchantID}
              invoice={OrderNumber}
              amount={sum}
              currency={currency}
              allow_currencies={currency}
              item_number={"CRWD"}
              item_name={"CONDA CRWD Token"}
              first_name={first_name}
              last_name={last_name}
              email={email}
              success_url={window.location.href}
              cancel_url={window.location.href}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

PaymentInfoDASH.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PaymentInfoDASH);
